/**
 * Returns true for in-app paths safe to use as a post-login redirect.
 * Rejects open redirects (absolute / protocol-relative URLs) and auth loops.
 */
export default function isSafeRedirectPath(path) {
  if (typeof path !== 'string' || !path.startsWith('/') || path.startsWith('//')) {
    return false;
  }

  const pathname = path.split(/[?#]/)[0];
  return pathname !== '/login' && pathname !== '/logout';
}
